import React from "react";
import "./CardsImg.css";

const CardImg = ({ image, heading, detail }) => {
  return (
    <div className="card">
      <img src={image} alt={heading} loading="lazy" className="card-img" />
      <p
        style={{ fontFamily: "Ginebra", color: "#3B3A2E" }}
        className="heading"
      >
        {heading}
      </p>
      <p className="details">{detail}</p>
      {/* <button className="c-button">LEARN MORE</button> */}
    </div>
  );
};

export default CardImg;
